import React, { FC } from "react";
import clsx from "clsx";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../themes";
import InfoIcon from "../InfoIcon";

const useStyles = makeStyles({
  label: {
    fontSize: 14,
    fontWeight: 400,
    color: "#a1a4ac",
    "& > span": {
      lineHeight: "inherit",
    },
  },
  asterisk: {
    lineHeight: "inherit",
    marginLeft: 3,
  },
  hasError: {
    color: `${theme.palette.error.main} !important`,
  },
});

interface IWeduLabel {
  label: string;
  labelStyles?: any;
  asteriskStyles?: any;
  isRequired?: boolean;
  hasError?: boolean;
  infoIcon?: string;
}

export const WeduLabel: FC<IWeduLabel> = ({
  label,
  labelStyles,
  asteriskStyles,
  isRequired = false,
  hasError = false,
  infoIcon,
}) => {
  const classes = useStyles();

  return (
    <InputLabel className={labelStyles}>
      {label}
      {isRequired && (
        <Typography
          className={clsx(
            classes.asterisk,
            hasError && classes.hasError,
            asteriskStyles,
            labelStyles,
          )}
          component={"span"}
          variant={"subtitle2"}
        >
          *
        </Typography>
      )}
      {infoIcon && <InfoIcon text={infoIcon} />}
    </InputLabel>
  );
};
